module.exports = __webpack_public_path__ + "static/media/unsuccessful.0f9a833a.svg";